// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.0 (commit ).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
import { SetMap as __SetMap } from "./set_map_type";
import { SetChar as __SetChar } from "./set_char_type";
import { SetFog as __SetFog } from "./set_fog_type";

export type SetEncounterData = {
  map: __SetMap | undefined,
  characters: __SetChar[] | undefined,
  fog: __SetFog[] | undefined,
};

/**
 * A namespace for generated helper functions.
 */
export namespace SetEncounterData {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("map", AlgebraicType.createOptionType(__SetMap.getTypeScriptAlgebraicType())),
      new ProductTypeElement("characters", AlgebraicType.createOptionType(AlgebraicType.createArrayType(__SetChar.getTypeScriptAlgebraicType()))),
      new ProductTypeElement("fog", AlgebraicType.createOptionType(AlgebraicType.createArrayType(__SetFog.getTypeScriptAlgebraicType()))),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: SetEncounterData): void {
    SetEncounterData.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): SetEncounterData {
    return SetEncounterData.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


